/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Type_ZipInputs */

const en_media_type_zip = /** @type {(inputs: Media_Type_ZipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compressed Archive`)
};

const id_media_type_zip = /** @type {(inputs: Media_Type_ZipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arsip Terkompresi`)
};

/** @type {(inputs: Media_Type_ZipInputs) => LocalizedString} */
const es_media_type_zip = en_media_type_zip;

/** @type {(inputs: Media_Type_ZipInputs) => LocalizedString} */
const fr_media_type_zip = en_media_type_zip;

/** @type {(inputs: Media_Type_ZipInputs) => LocalizedString} */
const de_media_type_zip = en_media_type_zip;

/** @type {(inputs: Media_Type_ZipInputs) => LocalizedString} */
const ja_media_type_zip = en_media_type_zip;

/** @type {(inputs: Media_Type_ZipInputs) => LocalizedString} */
const zh_media_type_zip = en_media_type_zip;

/** @type {(inputs: Media_Type_ZipInputs) => LocalizedString} */
const ar_media_type_zip = en_media_type_zip;

/** @type {(inputs: Media_Type_ZipInputs) => LocalizedString} */
const it_media_type_zip = en_media_type_zip;

/** @type {(inputs: Media_Type_ZipInputs) => LocalizedString} */
const ru_media_type_zip = en_media_type_zip;

/** @type {(inputs: Media_Type_ZipInputs) => LocalizedString} */
const pt_media_type_zip = en_media_type_zip;

/** @type {(inputs: Media_Type_ZipInputs) => LocalizedString} */
const ko_media_type_zip = en_media_type_zip;

/**
* | output |
* | --- |
* | "Compressed Archive" |
*
* @param {Media_Type_ZipInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const media_type_zip = /** @type {((inputs?: Media_Type_ZipInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Type_ZipInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_media_type_zip(inputs)
	if (locale === "es") return es_media_type_zip(inputs)
	if (locale === "fr") return fr_media_type_zip(inputs)
	if (locale === "de") return de_media_type_zip(inputs)
	if (locale === "ja") return ja_media_type_zip(inputs)
	if (locale === "zh") return zh_media_type_zip(inputs)
	if (locale === "ar") return ar_media_type_zip(inputs)
	if (locale === "id") return id_media_type_zip(inputs)
	if (locale === "it") return it_media_type_zip(inputs)
	if (locale === "ru") return ru_media_type_zip(inputs)
	if (locale === "pt") return pt_media_type_zip(inputs)
	return ko_media_type_zip(inputs)
});